<template>
  <div class="filter-top">
    <div class="like-select-box">
      <div class="like-select-top">
        <i class="iconfont icon-filter c-gray-light" />
        <span v-if="!!activeAllCount" class="like-select-count">{{ activeAllCount }}</span>
        <span class="like-select-name">{{ active_parent_key }}</span>
        <i class="el-icon-arrow-down c-gray-light" />
      </div>
      <div class="like-select-bottom">
        <div class="like-select-list">
          <div v-for="(item, index) in listParent" :key="index" class="like-select-item">
            <div
              :class="{
                'like-select-name': true,
                active: !!activeItemCount(item),
                current: item.key === active_parent_key
              }"
              :title="`切换到${item.key}`"
              @click="itemParentToggle(item.key)"
            >
              <span class="like-select-key">{{ item.key }}</span>
              <span v-if="activeItemCount(item)" class="like-select-count">{{
                activeItemCount(item)
              }}</span>
            </div>
            <span
              v-if="activeItemCount(item)"
              class="el-icon-close"
              :title="`清空${item.key}`"
              @click="activeListClear(index)"
            />
          </div>
        </div>
        <div class="like-select-clear" @click="activeListClear('all')" title="清空全部">
          <i class="iconfont icon-clear" />
          <span class="m-l-2">清空筛选</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active_parent_key: {
      type: String,
      required: true
    },
    listParent: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    // 选中全部数量
    activeAllCount() {
      let result = 0
      this.listParent.forEach((itemSt) => {
        itemSt.list.forEach((itemNd) => {
          result += itemNd.active.length
        })
      })
      return result
    }
  },
  methods: {
    // 项父级切换
    itemParentToggle(val) {
      this.$emit('update:active_parent_key', val)
    },
    // 选中列表清空
    activeListClear(val) {
      this.$emit('clear', val)
    },
    // 选中项数量
    activeItemCount(val) {
      let result = 0
      val.list.forEach((item) => {
        result += item.active.length
      })
      return result
    }
  }
}
</script>

<style lang="less" scoped>
.filter-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 5px;
  .like-select-box {
    position: relative;
    z-index: 100;
    color: @colorGray;
    &:hover {
      .like-select-top {
        border-color: #bbb;
        border-radius: 5px 0 0 5px;
      }
      .like-select-bottom {
        display: block;
      }
    }
    .like-select-top {
      position: relative;
      z-index: 9;
      display: flex;
      align-items: center;
      height: 26px;
      padding: 0 5px;
      border: 1px solid #ddd;
      border-radius: 5px;
      .like-select-name {
        flex: 1;
        padding: 0 5px;
        font-weight: bold;
      }
    }
    .like-select-bottom {
      display: none;
      position: absolute;
      top: 0;
      left: 100%;
      margin-left: -3px;
      line-height: 26px;
      background: #eee;
      border: 1px solid #bbb;
      border-radius: 0 0 5px 5px;
      z-index: 101;
      .like-select-list {
        display: flex;
        flex-wrap: wrap;
        width: 390px;
        padding: 5px 5px 10px 0;
        .like-select-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 125px;
          margin: 5px 0 0 5px;
          cursor: pointer;
          border-radius: 5px;
          overflow: hidden;
          .like-select-name {
            display: flex;
            align-items: center;
            flex: 1;
            padding: 0 5px;
            color: @colorGrayDeep;
            &:hover,
            &.active {
              color: @colorGreen;
              background: @colorGreen20;
            }
            &.current {
              color: @colorBlue;
              background: @colorBlue20;
            }
            .like-select-key {
              font-weight: bold;
            }
          }
          .el-icon-close {
            width: 26px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            color: @colorRed;
            background: @colorRed20;
          }
        }
      }
      .like-select-clear {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        border-top: 1px solid #bbb;
        cursor: pointer;
        &:hover {
          color: @colorRed;
          background: @colorRed20;
        }
      }
    }

    .like-select-count {
      margin-left: 2px;
      padding: 1px 4px;
      line-height: 1;
      color: @colorWhite;
      background: @colorGreen;
      border-radius: 2px;
    }
  }
}
</style>
